import { useTranslation } from 'react-i18next';

import { DealRowActionType } from '../../../constants';

export const useDealRowActionTranslations = () => {
  const { t } = useTranslation();

  return {
    [DealRowActionType.DETAILS]: t('Details'),
    [DealRowActionType.CLONE]: t('Clone'),
    [DealRowActionType.EDIT]: t('Edit'),
    [DealRowActionType.TROUBLESHOOT]: t('Troubleshoot'),
    [DealRowActionType.DELETE]: t('Delete'),
    [DealRowActionType.PAUSE]: t('Pause'),
    [DealRowActionType.RESUME]: t('Resume'),
    [DealRowActionType.USE_SHARED_TARGETING]: t('Use Shared Targeting'),
    [DealRowActionType.DOWNLOAD]: t('Download'),
  };
};
